import styled from 'styled-components';

import { colors } from 'global/colors';

const getProgressColor = (barType) => {
  switch (barType) {
    case 'track':
      return colors.lightBlue12;
    case 'success':
      return colors.green2;
    case 'warning':
      return colors.yellow;
    case 'danger':
      return colors.red;
    default:
      return colors.lightBlue12;
  }
};

export const Progress = styled.div`
  position: 'inherit';
  background-color: ${({ barType }) => getProgressColor(barType)};
  width: ${({ percent }) => `${percent ? percent : 0}%`};
`;

export const ProgressContainer = styled.div.attrs(() => ({ className: 'progress' }))`
  width: 100%;
  background-color: ${({ isMultichoice, theme }) =>
    isMultichoice ? '#DFE4EA' : theme.freecode.buttonBackground}; !important;
`;
